import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/velanapp/public_html/vapps_v2/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/velanapp/public_html/vapps_v2/src/components/privacy/Privacy.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/velanapp/public_html/vapps_v2/src/components/shared/PageBanner.jsx");
